import React from 'react'
const Calendar = () => {
  return <h2>Calendario em desenvolvimento 🥳</h2>
}

export default Calendar